var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "10.7818mm",
    height: "7.612mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 216.82 153.08",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993234276272"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    x: 45.92,
    y: 118.71,
    width: 126.9,
    height: 4.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993234275936"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    y: 148.61,
    width: 216.82,
    height: 4.47
  })), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M78.43 46.24c-8.34,0 -15.11,-6.77 -15.11,-15.11 0,-8.34 6.77,-15.11 15.11,-15.11 8.34,0 15.11,6.77 15.11,15.11 0,0.02 0,0.04 0,0.05 0,-0 0,-0 0,-0 0,8.32 -6.74,15.06 -15.06,15.06 -0.02,0 -0.04,0 -0.05,0zm0 -25.65c-5.87,0 -10.64,4.77 -10.64,10.64 0,5.88 4.77,10.64 10.64,10.64 5.88,0 10.64,-4.77 10.64,-10.64 0,-5.88 -4.77,-10.64 -10.64,-10.64l-0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M136.96 46.24c-8.34,0 -15.11,-6.77 -15.11,-15.11 0,-8.34 6.77,-15.11 15.11,-15.11 8.34,0 15.11,6.77 15.11,15.11 0,0.02 0,0.04 0,0.05 0,-0 0,-0 0,-0 0,8.32 -6.74,15.06 -15.06,15.06 -0.02,0 -0.04,0 -0.05,0l0 0zm0 -25.65c-5.88,0 -10.64,4.77 -10.64,10.64 0,5.88 4.77,10.64 10.64,10.64 5.88,0 10.64,-4.77 10.64,-10.64 0,-5.88 -4.77,-10.64 -10.64,-10.64z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993234275744"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M32.56 135.15c-8.26,-0.12 -14.9,-6.85 -14.9,-15.11 0,-8.34 6.77,-15.11 15.11,-15.11 8.34,0 15.11,6.77 15.11,15.11 0,0.02 0,0.03 0,0.05 -0.03,8.32 -6.79,15.06 -15.11,15.06 -0.07,0 -0.14,-0 -0.21,-0l-0 0zm0 -25.65c-5.87,-0 -10.64,4.76 -10.64,10.64 0,5.88 4.77,10.64 10.64,10.64 5.88,0 10.64,-4.77 10.64,-10.64 0,-5.88 -4.77,-10.64 -10.64,-10.64l-0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993234281648"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M185.64 135.15c-0.02,-0 -0.04,-0 -0.05,-0 -8.34,0 -15.11,-6.77 -15.11,-15.11 0,-8.34 6.77,-15.11 15.11,-15.11 8.34,0 15.11,6.77 15.11,15.11 0,0.02 0,0.04 0,0.05 -0.03,8.3 -6.75,15.03 -15.06,15.06l-0 0zm0 -25.65c-5.88,-0 -10.64,4.76 -10.64,10.64 0,5.88 4.77,10.64 10.64,10.64 5.88,0 10.64,-4.77 10.64,-10.64 0,-5.88 -4.77,-10.64 -10.64,-10.64l0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993234278672"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    y: 118.71,
    width: 19.69,
    height: 4.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993234280352"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 197.08,
    y: 118.71,
    width: 19.69,
    height: 4.47
  })), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M169.58 91.04l-4.47 0 0 -86.57 -113.39 0 0 86.57 -4.47 0 0 -91.04 122.33 0 0 91.04z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 0,
    y: 88.8,
    width: 51.45,
    height: 4.47
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 165.37,
    y: 88.8,
    width: 51.45,
    height: 4.47
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc28);
export default __webpack_public_path__ + "static/media/ic_2_8.ea8a4be958990a859398432e4c2faeba.svg";
export { ForwardRef as ReactComponent };